import { AbstractPage } from 'starting-blocks'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class DefaultPage extends AbstractPage {
  constructor(container) {
    super(container, 'DefaultPage')
  }

  init() {
    super.init()
    gsap.to('.js-main', {
      scrollTrigger: {
        trigger: '.js-scroll-hero',
        scrub: 1,
        // markers: true,
        start: 'top top', // when the top of the trigger hits the top of the viewport
      },
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
    })
  }

  initEvents() {
    super.initEvents()
  }

  destroyEvents() {
    super.destroyEvents()
  }

  onLazyImageProcessed(index) {
    super.onLazyImageProcessed(index)
  }

  onResize() {
    super.onResize()
  }

  onLazyImageSet(element) {
    super.onLazyImageSet(element)
  }

  onLazyImageLoad(element) {
    super.onLazyImageLoad(element)
  }
}
